(function () {
    'use strict';

    angular
        .module('procedureModule', [
        ]);
})();